import React, { useEffect, useState } from "react";
import { Button, Card, Modal, Spinner, Alert } from "react-bootstrap";
import bookimg1 from "../../../assets/img/bookimg1.jpg"; // Fallback image
import { userCharacterList } from "../../../api/taleService";
import { Link, useParams } from "react-router-dom";
import DataTable from "react-data-table-component";
import { Icon } from "@iconify/react";

export default function CharacterTab() {
  const [searchText, setSearchText] = useState("");
  const [userCharacterListData, setUserCharacterListData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const { userId } = useParams();

  useEffect(() => {
    if (userId) fetchUserCharacters();
  }, [userId, searchText]);

  const fetchUserCharacters = async () => {
    setLoading(true);
    setError("");

    try {
      const response = await userCharacterList({
        userId,
        character_name: searchText.trim(),
      });

      if (response?.data) {
        const updatedData = response.data.map((item, index) => ({
          ...item,
          SrNo: index + 1,
        }));
        setUserCharacterListData(updatedData);
      } else {
        setError("Failed to retrieve characters. Please try again later.");
      }
    } catch (err) {
      console.error("Error fetching characters:", err);
      setError("An error occurred while fetching characters.");
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      name: "Sr No.",
      width: "100px",
      selector: (row) => row.SrNo,
      sortable: true,
    },
    {
      name: "Image",
      minWidth: "280px",
      selector: (row) => row.character_image,
      sortable: false,
      cell: (row) => (
        <img
          className="table_img rounded-circle img-thumbnail"
          src={row.character_image}
          alt="character"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = bookimg1; // Replace this
          }}
          style={{ width: 70, height: 70 }}
        />
      ),
    },
    {
      name: "Name",
      minWidth: "190px",
      selector: (row) => row.character_name,
      sortable: true,
    },
    {
      name: "Type",
      minWidth: "190px",
      selector: (row) => row.character_setting,
      sortable: true,
    },
    {
      name: "Actions",
      width: "150px",
      cell: (row) => (
        <>
          <Link className="btnview" to={`/admin/character-detail/${row._id}`}>
                      <Icon icon="tabler:eye" />
                    </Link>
          {/* <Link className="btndelete" onClick={handleShow}>
            <Icon icon="tabler:trash" />
          </Link> */}
        </>
      ),
    },
  ];

  return (
    <React.Fragment>
      <Card>
        <Card.Body className="bookingtable mt-3">
          <div className="text-end mb-3">
            <input
              type="text"
              placeholder="Search..."
              className="searchfield"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />
          </div>

          {loading ? (
            <div className="d-flex justify-content-center align-items-center" style={{ height: "200px" }}>
              <Spinner animation="border" variant="primary" />
            </div>
          ) : error ? (
            <Alert variant="danger" className="text-center">{error}</Alert>
          ) : (
            <DataTable
              columns={columns}
              data={userCharacterListData}
              pagination
              responsive
              className="custom-table"
              noDataComponent={<p className="text-center my-4">No characters found.</p>}
            />
          )}
        </Card.Body>
      </Card>

      <Modal className="modal_Delete" show={show} onHide={handleClose} centered>
        <Modal.Body>
          <div className="modaldelete_div">
            <Icon className="delete_icon" icon="gg:close-o" />
            <h3>Are You Sure?</h3>
            <p>You will not be able to recover the deleted record!</p>
          </div>
          <Button onClick={handleClose} className="btn btn-primary-outline px-4 me-3">Cancel</Button>
          <Button className="btn btn-primary px-4 min_width110" onClick={handleClose}>Ok</Button>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
}
